module.exports = __webpack_public_path__ + "img/botomimg2.ca79d143.png";